import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import userImg from "../../assets/images/icon-user.png";
import { getPathName } from "../../config/navItems";
import { useDispatch, useSelector } from "react-redux";
import { logoutUser } from "../../redux/actions/authentication/authentication";
import Chip from "@mui/material/Chip";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";

import Popover from "@mui/material/Popover";

// components
import SideBar from "./components/sidebar/SideBar";

// icons
import MenuIcon from "@material-ui/icons/Menu";

// styles
import styles from "./Header.module.scss";

const Header: React.FC = () => {
  const { pathname } = useLocation();

  const dispatch = useDispatch();

  const userId = useSelector((state: any) => state.authentication.user?.UserId);
  /*  const environmentName = useSelector(
    (state: any) => state.authentication.user?.EnvironmentName
  ); */
  const userCompanyName = useSelector(
    (state: any) => state.authentication.user?.CompanyName
  );

  //console.log("User Id: " + userId);

  const [expanded, setExpanded] = useState(false);
  const [isOnline, setIsOnline] = useState(true);

  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(
    null
  );

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    setAnchorEl(null);
    dispatch(logoutUser());
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const toggleSidebar = () => setExpanded(!expanded);

  window.addEventListener(
    "offline",
    function (e) {
      setIsOnline(false);
    },
    false
  );

  window.addEventListener(
    "online",
    function (e) {
      setIsOnline(true);
    },
    false
  );

  return pathname === "/login" ? null : (
    <div className={styles.header_wrapper}>
      <div className={styles.navbar}>
        <MenuIcon
          className={styles.nav_icon}
          fontSize="large"
          onClick={toggleSidebar}
        />
        <SideBar toggleSidebar={toggleSidebar} expanded={expanded} />
      </div>
      <span className={styles.header_title}>
        {getPathName(pathname).data?.name} - {userCompanyName}
      </span>
      {/*       <div className={styles.chip}>
        <Stack direction="row">
          {isOnline ? (
            <Chip label="online" color="success" variant="outlined" />
          ) : (
            <Chip label="offline" color="error" variant="outlined" />
          )}
        </Stack>
      </div> */}
      <Button aria-describedby={id} variant="text" onClick={handleClick}>
        <Chip
          avatar={<Avatar alt="UserPic" src={userImg} />}
          // label={userId + " (" + environmentName + ")"}
          label={userId}
        />
      </Button>

      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
      >
        <Button onClick={handleLogout} style={{ color: "black" }}>
          Log Out
        </Button>
      </Popover>
      {/*       <UncontrolledDropdown>
        <DropdownToggle
          id={styles.dropdown_toggle}
          className={styles.user_profile_pic}
        >
          <span className={styles.user_name}>{userId}</span>
          <img
            src={userImg}
            className={styles.user_profile}
            alt="User Profile"
          />
        </DropdownToggle>
        <DropdownMenu right>
          <DropdownItem onClick={() => dispatch(logoutUser())}>
            Logout
          </DropdownItem>
        </DropdownMenu>
      </UncontrolledDropdown> */}
    </div>
  );
};

export default Header;
